function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-fb8f72b0\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppText.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppText.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fb8f72b0\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppText.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fb8f72b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/typography/Text/AppText.vue
// module id = 0d4bc4b423a95eed5190
// module chunks = 89